import { HTTP } from './common'

export const Config = {
  get () {
    return HTTP.get('config/1/').then(response => {
      return response;
    });
  },
}
